import React, { useEffect } from 'react';

import { resetAllSteps } from 'prequalificationV2/actions/stages';
import styles from 'prequalificationV2/pages/NotQualified/NotQualified.module.scss';
import { InfoIcon } from 'assets/images';
import { useAppDispatch } from 'prequalificationV2/hooks/useAppDispatch';
import FormHeader from 'prequalificationV2/components/FormHeader';

const NotQualified = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  });

  return (
    <>
      <FormHeader>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>Unfortunately, you do not qualify based on the information you provided.</h1>
          <InfoIcon className={styles.infoIcon} />
        </div>
      </FormHeader>
    </>
  );
};

export default NotQualified;
